import { useState } from 'react';

import { IconButton } from '@flipster/react/design-system/icon-button';
import { Portal } from '@flipster/react/misc/portal';
import { getServerEnv } from '@flipster/utils/env-helper';

import { FlipsterLogo } from '../shared/logo';
import { Panel } from './panel';

export const PrexDevTool = () => {
  const [isShowPanel, setIsShowPanel] = useState<boolean>(false);

  return (
    <Portal selector='body'>
      {!isShowPanel && (
        <IconButton
          hierarchy='secondary'
          size='medium'
          icon={<FlipsterLogo css={{ w: 16 }} />}
          onClick={() => setIsShowPanel(true)}
          css={{ zIndex: 9999, pos: 'fixed', left: '50%', bottom: 12, transform: 'translateX(-50%)' }}
        />
      )}
      {isShowPanel && <Panel onClose={() => setIsShowPanel(false)} />}
    </Portal>
  );
};

export function enabledPrexDevTool() {
  return getServerEnv() !== 'prod';
}
